import { useEffect } from "react";
import { useDaily } from "@daily-co/daily-react";
import Call from "./components/Call";

export default function CallScreen({ url, handleEnd }) {
    const daily = useDaily();

    useEffect(() => {
        if (daily) {
            // Get noise cancellation preference from localStorage
            const noiseCancellationEnabled = localStorage.getItem('noiseCancellation') !== 'false';
            
            daily.join({
                url,
                // Configure audio settings with noise suppression
                audioSource: true,
                // Add noise suppression settings using the correct format
                inputSettings: {
                    audio: {
                        processor: {
                            type: noiseCancellationEnabled ? 'noise-cancellation' : 'none'
                        }
                    }
                }
            }).catch(error => {
                console.error("Failed to join call:", error);
            });
        }
    }, [daily, url]);

    const handleLeave = async () => {
        await daily?.leave();
        handleEnd();
    }
    
    return (
        <div className="w-full h-full bg-gray-900 flex flex-col">
            <div className="flex-1 relative">
                <Call handleEnd={handleLeave} />
            </div>
        </div>
    );
}